import { shuffle } from 'lodash';

export function shuffleArray<T>(items: T[], count: number) {
  return shuffle(items).slice(0, count);
}
